import { render, staticRenderFns } from "./VoucherStats.vue?vue&type=template&id=43f65849&"
import script from "./VoucherStats.vue?vue&type=script&lang=js&"
export * from "./VoucherStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43f65849')) {
      api.createRecord('43f65849', component.options)
    } else {
      api.reload('43f65849', component.options)
    }
    module.hot.accept("./VoucherStats.vue?vue&type=template&id=43f65849&", function () {
      api.rerender('43f65849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/VoucherStats.vue"
export default component.exports